import React from 'react';
import urls, { relativeUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const AuditLauncherMenu = () => (
  <RibbonMenu
    name="activity"
    icon="history"
    message="fair.launcher.audit"
    url={`#${relativeUrl(urls.AUDIT)}`}
    className="aridhia-audit-launcher-menu"
  />
);

export default AuditLauncherMenu;
